import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypePagePersonSkeleton } from './TypePagePerson';

export interface TypeBlockPeopleListFields {
    internalName?: EntryFieldTypes.Symbol;
    peoplePages?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypePagePersonSkeleton>>;
}

export type TypeBlockPeopleListSkeleton = EntrySkeletonType<TypeBlockPeopleListFields, 'blockPeopleList'>;
export type TypeBlockPeopleList<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockPeopleListSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockPeopleList<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockPeopleList<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockPeopleList';
}
